







































































import Component from 'vue-class-component';
import TabsInfoMixin from '../../devices/TabsInfoMixin';
import { Mixins } from 'vue-mixin-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import { Global } from '@/store';

@Component({
  components: {}
})
class DaliTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Global.State('lang') lang;
  @Global.State('readonly_user') readonly_user;

  // @ts-ignore
  @Prop() device;
  @Prop() daliResponse: string;
  @Prop() sendDaliCommand: (command: string) => void;

  loading = false;
  statusMessage = 'Press "Query DALI" to query the driver\'s memory bank';
  daliData: Array<{address: string, value: string}> = [];
  timeoutHandle = null;
  
  // Initialization state management
  initializationState: 'checking' | 'ready' | 'error' = 'checking';
  initMessage = 'Checking DALI availability...';
  initStep = 0; // 0: relaystat=1, 1: daliscan?
  daliScanResponse = '';

  mounted() {
    this.resetState();
    // Delay initialization to ensure MQTT listener is ready
    setTimeout(() => {
      this.checkDaliAvailability();
    }, 500);
  }

  get tableHeaders() {
    return  [
        { text: this.$t('Address'), value: 'address', sortable: false, class: [this.lang === 'en' ? 'text-xs-left' : 'text-xs-right'] },
        { text: this.$t('Value'), value: 'value', sortable: false, class: [this.lang === 'en' ? 'text-xs-left' : 'text-xs-right'] }
    ];
  }

  @Watch('device')
  onDeviceChanged() {
    this.resetState();
  }

  @Watch('daliResponse')
  onDaliResponse(response: string) {
    if (!response) return;

    // console.log('DALI Response received:', response, 'Init state:', this.initializationState, 'Init step:', this.initStep);

    // Handle initialization sequence
    if (this.initializationState === 'checking') {
      this.handleInitializationResponse(response);
      return;
    }

    // Handle normal operation responses
    this.clearTimeout();
    this.loading = false;

    if (response === 'OK') {
      // OK response
      if (this.statusMessage.includes(this.$t('Initializing'))) {
        this.statusMessage = this.$t('Bus initialized successfully');
      } else if (this.statusMessage.includes(this.$t('Querying'))) {
        // OK from query means no data found
        this.statusMessage = this.$t('No DALI data available (OK response)');
        this.daliData = [];
      }
    } else if (response === 'ERROR') {
      // ERROR response
      if (this.statusMessage.includes(this.$t('Initializing'))) {
        this.statusMessage = this.$t('Error initializing DALI bus');
      } else if (this.statusMessage.includes(this.$t('Querying'))) {
        this.statusMessage = this.$t('Error querying DALI driver');
        this.daliData = [];
      }
    } else if (typeof response === 'string' && response.length > 0) {
      // Hex string response or other data
      this.parseDaliHexResponse(response);
    }
  }

  resetState() {
    this.loading = false;
    this.statusMessage = this.$t('Press "Query DALI" to query the driver\'s memory bank');
    this.daliData = [];
    this.initializationState = 'checking';
    this.initMessage = `${this.$t('Checking DALI availability')}...`;
    this.initStep = 0;
    this.daliScanResponse = '';
    this.clearTimeout();
  }

  checkDaliAvailability() {
    // console.log('Starting DALI availability check');
    this.initializationState = 'checking';
    this.initStep = 0;
    this.initMessage = `${this.$t('Checking relay status')}...`;
    this.sendDaliCommand('AT+relaystat=1');
    this.startInitTimeout();
  }

  handleInitializationResponse(response: string) {
    // console.log('Handling init response - Step:', this.initStep, 'Response:', response);
    this.clearTimeout();

    if (this.initStep === 0) {
      // Response to AT+relaystat=1
      if (response === 'OK') {
        // console.log('Relay stat command OK, checking DALI scan');
        this.initStep = 1;
        this.initMessage = `${this.$t('Checking DALI scan status')}...`;
        this.sendDaliCommand('AT+daliscan?');
        this.startInitTimeout();
      } else {
        // console.log('Relay stat command failed:', response);
        this.initializationState = 'error';
        this.initMessage = this.$t('DALI is not available on this device. Relay status command failed.');
      }
    } else if (this.initStep === 1) {
      // Response to AT+daliscan? - Validate it returns 0 or higher number
      // console.log('DALI scan response received:', response);
      this.daliScanResponse = response;
      this.clearTimeout();
      
      // Check if response is a valid number (0 or higher)
      const scanValue = parseInt(response, 10);
      if (!isNaN(scanValue) && scanValue >= 0) {
        // console.log('DALI scan valid:', scanValue);
        this.initializationState = 'ready';
        // console.log('Initialization complete - DALI is ready');
        // console.log('DALI Scan:', this.daliScanResponse);
      } else {
        // console.log('DALI scan invalid response:', response);
        this.initializationState = 'error';
        this.initMessage = `${this.$t('DALI initialization failed')}. ${this.$t('Invalid scan response')}: ${response}`;
      }
    }
  }

  startInitTimeout() {
    this.clearTimeout();
    this.timeoutHandle = setTimeout(() => {
      // console.log('Initialization timeout at step:', this.initStep);
      this.initializationState = 'error';
      this.initMessage = `${this.$t('DALI initialization timeout')}. ${this.$t('Device may not support DALI or is not responding')}.`;
    }, 10000);
  }

  queryDali() {
    this.loading = true;
    this.statusMessage = `${this.$t('Querying driver')}...`;
    this.daliData = [];
    this.sendDaliCommand('AT+dalibank?0,0');
    this.startTimeout(this.$t('No answer from driver - check if DALI is initialized or if the driver is properly connected'));
  }

  initDali() {
    this.loading = true;
    this.statusMessage = `${this.$t('Initializing DALI bus')}...`;
    this.daliData = [];
    this.sendDaliCommand('AT+initdali');
    this.startTimeout(this.$t('Timeout - cannot initialize bus'));
  }

  startTimeout(timeoutMessage: string) {
    this.clearTimeout();
    this.timeoutHandle = setTimeout(() => {
      this.loading = false;
      this.statusMessage = timeoutMessage;
    }, 20000);
  }

  clearTimeout() {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
  }

  parseDaliHexResponse(hexString: string) {
    // Parse hex string response and extract address-value pairs
    // Expected format: "0,0,1aMM8307edfad3c1290200e0024c6e9c944b8003010808ff000100MMMM..."
    try {
      // console.log('Parsing DALI hex response:', hexString);
      this.daliData = [];
      
      // Remove all whitespace and commas
      let cleanHex = hexString.replace(/[\s,]/g, '');
      
      // console.log('After removing whitespace and commas:', cleanHex);
      
      // Remove leading "00" if the string starts with it (from "0,0," prefix)
      if (cleanHex.startsWith('00')) {
        cleanHex = cleanHex.substring(2);
      }
      
      // console.log('After removing leading 00:', cleanHex);
      
      // Convert to uppercase for consistency
      cleanHex = cleanHex.toUpperCase();
      
      // Parse pairs of characters (2 chars = 1 byte)
      const hexPairs = cleanHex.match(/.{1,2}/g) || [];
      
      // console.log('Hex pairs:', hexPairs);
      
      // Create address-value pairs - only display first 3 addresses (0x00, 0x01, 0x02)
      const maxAddresses = 3;
      for (let i = 0; i < Math.min(hexPairs.length, maxAddresses); i++) {
        const pair = hexPairs[i];
        const address = '0x' + i.toString(16).toUpperCase().padStart(2, '0');
        
        // Check for special codes
        let value: string;
        if (pair === 'MM') {
          value = 'MM (No frame received)';
        } else if (pair === 'VI') {
          value = 'VI (Bus busy)';
        } else if (pair === 'VJ') {
          value = 'VJ (Collision detected)';
        } else if (pair === 'V0') {
          value = 'V0 (General failure)';
        } else if (pair === 'VV') {
          value = 'VV (Invalid/corrupt frame)';
        } else if (/^[0-9A-F]{2}$/.test(pair)) {
          // Valid hex pair - normal data
          value = '0x' + pair;
        } else {
          // Invalid format
          value = pair + ' (Invalid)';
        }
        
        this.daliData.push({
          address,
          value
        });
      }
      
      // console.log('Parsed DALI data:', this.daliData);
      
      if (this.daliData.length > 0) {
        this.statusMessage = `${this.$t('DALI Memory Bank Data')} (${this.daliData.length} ${this.$t('bytes')})`;
      } else {
        this.statusMessage = this.$t('No valid DALI data found in response');
      }
    } catch (error) {
      console.error('Error parsing DALI response:', error);
      this.statusMessage = this.$t('Error parsing DALI response');
      this.daliData = [];
    }
  }

  beforeDestroy() {
    this.clearTimeout();
  }
}

export default DaliTab;
